import { render, staticRenderFns } from "./ExcludedProductsEditForm.vue?vue&type=template&id=20b91c23&scoped=true&"
import script from "./ExcludedProductsEditForm.vue?vue&type=script&lang=ts&"
export * from "./ExcludedProductsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./ExcludedProductsEditForm.vue?vue&type=style&index=0&id=20b91c23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b91c23",
  null
  
)

export default component.exports